// Retrieve user data from session storage
export const getUser = () => {
    const user = sessionStorage.getItem('user')
    return user ? JSON.parse(user) : null
}

// Retrieve token from local storage
export const getToken = () => {
    return localStorage.getItem('token') || null
}

// Remove token and user from browser storage
export const removeSession = () => {
    localStorage.removeItem('token')
    sessionStorage.removeItem('user')
}

// Set token and user to browser storage
export const setSession = (token, user) => {
    localStorage.setItem('token', token)
    sessionStorage.setItem('user', JSON.stringify(user))
}

// Update user from session storage
export const updateUser = (name, phone) => {
    const user = JSON.parse(sessionStorage.getItem('user'))

    if (user) {
        user.name = name

        sessionStorage.removeItem('user')
        sessionStorage.setItem('user', JSON.stringify(user))
    }
}